import { MARKET_ROUTE } from './constants';

/**
 * `/market/*` sub-route contract — FROZEN. `MarketplaceView` dispatches on
 * this; every marketplace surface builds links through it.
 *
 *   /market                      → shelf (all products)
 *   /market/<category-slug>      → shelf filtered to a segment / manufacturer
 *   /market/product/<slug>       → product preview page
 *   /market/cart                 → cart
 *   /market/checkout/success     → post-Stripe landing (?session_id=…)
 *   /market/checkout/cancel      → Stripe cancel landing
 */
export type MarketplaceRoute =
  | { kind: 'shelf'; categorySlug: string | null }
  | { kind: 'product'; slug: string }
  | { kind: 'cart' }
  | { kind: 'checkout'; result: 'success' | 'cancel' };

export const CART_ROUTE = `${MARKET_ROUTE}/cart`;
export const CHECKOUT_SUCCESS_ROUTE = `${MARKET_ROUTE}/checkout/success`;
export const CHECKOUT_CANCEL_ROUTE = `${MARKET_ROUTE}/checkout/cancel`;

export function productUrl(slug: string): string {
  return `${MARKET_ROUTE}/product/${slug}`;
}

export function parseMarketplacePath(pathname: string): MarketplaceRoute {
  if (pathname === MARKET_ROUTE || !pathname.startsWith(`${MARKET_ROUTE}/`)) {
    return { kind: 'shelf', categorySlug: null };
  }
  const parts = pathname
    .slice(MARKET_ROUTE.length + 1)
    .split('/')
    .filter(Boolean);
  const [head, second] = parts;
  if (!head) return { kind: 'shelf', categorySlug: null };
  if (head === 'product' && second) return { kind: 'product', slug: second };
  if (head === 'cart') return { kind: 'cart' };
  if (head === 'checkout') {
    // 'success' must be spelled EXACTLY. Anything else under /market/checkout —
    // a bare /market/checkout, a typo, a truncated Stripe redirect, a stale
    // bookmark — falls back to 'cancel', which is the safe side: cancel clears
    // nothing and claims nothing. Defaulting the other way meant merely opening
    // /market/checkout emptied the buyer's cart and told them they had paid.
    return {
      kind: 'checkout',
      result: second === 'success' ? 'success' : 'cancel',
    };
  }
  return { kind: 'shelf', categorySlug: head };
}
